export default __webpack_public_path__ + "static/media/projectpage.b9034906.jpg";